import { CUSTOMER_JOURNEY_RESERVATION_SUCCESS } from './../const';

function action(data) {
  return { type: CUSTOMER_JOURNEY_RESERVATION_SUCCESS, data };
}

module.exports = action;



// WEBPACK FOOTER //
// ./actions/customerJourney/customerJourneyReservationSuccess.js